var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-test":"product-original-price"}},[_vm._v(" "+_vm._s(_vm.formattedMoney)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }